
document.addEventListener("DOMContentLoaded", function () {
    const openers = document.querySelectorAll('.filter__list-opener');

    openers.forEach(opener => {
        opener.addEventListener('click', function (e) {
            e.preventDefault();

            const listItem = opener.closest('.filter__list-item');

            if (listItem.classList.contains('active')) {
                listItem.classList.remove('active');
            } else {
                listItem.classList.add('active');
            }
        });
    });

    jQuery('body.post-type-archive-resources').on('click','.filter__list-item--topic li a, .filter__list-item--asset li a, .filter__list-item--sort li a',function (e){
        e.preventDefault();
        jQuery(this).parents('.filter__list-drop-wrap').find('li.active').removeClass('active');
        jQuery(this).parent().addClass('active');

        let resources_archive_url=jQuery('.filter').data('resources_archive_url');
        let resource_category=jQuery('.filter__nav li.active a').data('resource_category');
        let resource_topic=jQuery('.filter__list-item--topic li.active a').data('resource_topic');
        let resource_type=jQuery('.filter__list-item--asset li.active a').data('resource_type');
        let resource_order=jQuery('.filter__list-item--sort li.active a').data('order');
        let filter_url=resources_archive_url

        if(resource_category){
            filter_url+='?resource-category='+resource_category;
        }
        if(resource_topic){
            filter_url+='&resource-topic='+resource_topic;
        }
        if(resource_type){
            filter_url+='&resources-type='+resource_type;
        }
        if(resource_order){
            filter_url+='&order='+resource_order;
        }
        filter_url+='#filter'
        window.location.href=filter_url
    })


    jQuery('body.blog').on('click','.filter__list-item--topic li a, .filter__list-item--asset li a, .filter__list-item--sort li a',function (e){
        e.preventDefault();
		e.stopPropagation();
        jQuery(this).parents('.filter__list-drop-wrap').find('li.active').removeClass('active');
        jQuery(this).parent().addClass('active');

        let news_archive_url=jQuery('.filter').data('news_archive_url');
        let news_category=jQuery('.filter__nav li.active a').data('category');
        let news_topic=jQuery('.filter__list-item--topic li.active a').data('topic');
        let news_type=jQuery('.filter__list-item--asset li.active a').data('news_type');
        let news_order=jQuery('.filter__list-item--sort li.active a').data('order');
        let filter_url=news_archive_url

        if(news_category){
            filter_url+='?category='+news_category;
        }else{
			function random(min, max) {
				return Math.floor(Math.random() * (max - min + 1)) + min
			}
			filter_url+='?filter';
		}
        if(news_topic){
            filter_url+='&topic='+news_topic;
        }
        if(news_type){
            filter_url+='&news-type='+news_type;
        }
        console.log('news_type',news_type, 'filter_url',filter_url)
        if(news_order){
            filter_url+='&order='+news_order;
        }
        filter_url+='#filter'
		// console.log('filter_url', filter_url);
        window.location.href=filter_url

    })
});
